module.exports = __webpack_public_path__ + "static/media/liliana.ef76ff77.jpg";